/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon32Regular = forwardRef('ArrowUiAuthLoginIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11 3a1 1 0 0 1 1-1h10.5A5.5 5.5 0 0 1 28 7.5v17a5.5 5.5 0 0 1-5.5 5.5H12a1 1 0 1 1 0-2h10.5a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 22.5 4H12a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "m17.367 17-4.855 4.855a1 1 0 0 0 1.414 1.415l5.237-5.237a2.875 2.875 0 0 0 0-4.066L13.926 8.73a1 1 0 0 0-1.414 1.415L17.367 15H2a1 1 0 1 0 0 2h15.367Z" })));
});
